// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--2Y5FL","copyright":"footer-module--copyright--4FyNV"};